<div class="content-card h-100 d-flex flex-column p-3">

  <div class="poster-wrap position-relative clickable" (click)="previewRequested.emit(item)"
       [ngbTooltip]="'students.videos.preview'|translate" container="body">
    <app-content-poster
      [video]="item.video" [liveStream]="item.liveStream" [showProgress]="false"></app-content-poster>

    <span class="play-overlay position-absolute d-flex align-items-center justify-content-center">
      <i class="bi bi-play-fill"></i>
    </span>
  </div>

  <div class="d-flex align-items-center justify-content-between mt-3">
    <app-content-type-badge [type]="item.type"></app-content-type-badge>
    <span class="fs-xsmall fw-400 color-gray-400" *ngIf="item.date">{{item.date | date: 'd MMMM'}}</span>
  </div>

  <p class="fs-small fw-800 color-gray-950 mt-2 mb-0 card-title">{{item.title}}</p>

  <p class="fs-xsmall fw-400 color-gray-400 mb-0 mt-1" *ngIf="!item.canView">
    <i class="bi bi-lock me-1"></i>{{'students.videos.locked_for_student'|translate}}
  </p>

  <div class="mt-3 mt-auto pt-3">
    <div class="assigned-state d-flex align-items-center justify-content-center gap-2 fs-small fw-800 py-2"
         *ngIf="isAssigned">
      <i class="bi bi-check-circle-fill"></i>
      {{'students.videos.assigned_to'|translate: {name: studentName} }}
    </div>

    <app-gray-button
      *ngIf="!isAssigned"
      color="stroke-gray" [fullWidth]="true" padding="px-3 py-2 gap-1" [weight]="800"
      customClass="d-flex align-items-center justify-content-center fs-small border-8" preIcon="plus"
      [text]="'students.videos.assign'|translate"
      (click)="assignRequested.emit(item)"></app-gray-button>
  </div>

</div>
